export default __webpack_public_path__ + "static/media/sowmz-guitar-fixed-crop.44e13784.jpg";